
namespace RioERP.Users {
    export class VendorsColumns {
        static columnsKey = 'Users.Vendors';
    }
}